import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';
import { SidebarService } from './services/shared/sidebar.service';
import { filter } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { PrinterService } from './services/printer/printer.service';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { PushNotificationDataService } from './services/shared/push-notification-data.service';
import { SessionService } from './services/shared/session.service';
import { ThemeService } from './services/shared/theme.service';
import { EasterEggService } from './services/shared/easter-egg.service';
import { Helpers } from './models/helpers';
registerLocaleData(localeIt);

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})

export class AppComponent implements OnInit, OnDestroy {
  helpers = Helpers;

  title = 'Diakonix';
  hideSideBars: boolean = false;
  account: any;
  shouldDisplayContent: boolean = true;
  notificationData: any;

  constructor(
    public sidebarService: SidebarService,
    public authServ: AuthService,
    private router: Router,
    private printersService: PrinterService,
    private pushNotificationService: PushNotificationDataService,
    private session: SessionService,
    private themeService: ThemeService,
    private easterEgg: EasterEggService,
  ) {
    registerLocaleData(localeIt);
  }

  ngOnInit() {
    // this.initWonderPush();

    // v2.14.0 (Sprint 2 T-A F4): applica il tema salvato in
    // localStorage['diakonix.theme'] al boot, fallback a
    // prefers-color-scheme del sistema se mai settato dall'utente.
    // Deve stare PRIMA di ogni logica UI-dependent per evitare
    // "flash of unstyled content" (FOUC).
    this.themeService.init();

    // v2.14.2: attiva il global keyboard listener dell'easter egg
    // del maintainer. No-op se `secrets.ts` non ha EASTER_EGG.enabled=true
    // (default per la maggior parte degli utenti) → zero overhead.
    this.easterEgg.initialize();

    registerLocaleData(localeIt);
    this.account = this.session.getCurrentUser() ?? {};

    // Load printers once at boot — was previously called on EVERY
    // NavigationEnd (legacy bug), which fired `/get_printers/` at every
    // route change. The settings page calls this explicitly when the
    // user edits printers, so a single boot load is enough.

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        if (this.isLoginOrdersRoute()) {
          this.shouldDisplay();
        }
        if (this.isWarehouseOrdersRoute()) {
          this.shouldDisplay();
        }
        if (this.isAgentsOrdersRoute() || this.isClientOrdersRoute()) {
          this.hideSidebars();
        }
        if (
          this.session.isAuthenticated() &&
          this.account.ac_user_type_cod !== this.helpers.PermisionManufacturer &&
          !this.isAgentsOrdersRoute() &&
          !this.isClientOrdersRoute()
        ) {
          this.printersService.getPrinterSettings();
        }

      });
  }

  getCurrentRoute(url: string): string {
    const routeParts = url.split('?');
    const baseRoute = routeParts[0];
    return baseRoute.replace(/^\/|\/$/g, '');
  }

  isAgentsOrdersRoute(): boolean {
    return this.router.url.includes('agentsorders');
  }

  isClientOrdersRoute(): boolean {
    return this.router.url.includes('clientorders');
  }
  isLoginOrdersRoute(): boolean {
    return this.router.url.includes('login');
  }

  isWarehouseOrdersRoute(): boolean {
    return this.router.url.includes('warehouseorders');
  }

  isMessageRoute(): boolean {
    return this.router.url.includes('messages');
  }

  shouldDisplay() {
    this.shouldDisplayContent = false;
    console.log('Should display false');
  }

  hideSidebars() {
    this.sidebarService.isOpen = false;
    this.sidebarService.isOpenR = false;
    this.sidebarService.isBody = false;
  }

  showSidebars() {
    this.sidebarService.isOpen = true;
    this.sidebarService.isOpenR = true;
    this.sidebarService.isBody = true;
  }

  // v2.14.2: rimosso `goToAccDetails()` — era dead code (nessun
  // template lo chiamava, replicava logica orfana dalla sidebar
  // pre-refactor). Lo stesso flow ora vive in
  // SidebarComponent.goToAccDetails() con navigazione a
  // /accounts?openAccountId=<id>.

  /**
   * Cleanup app-level listener globali. In pratica il component vive
   * quanto l'app (AppComponent è il root), ma ngOnDestroy garantisce
   * la sequenza corretta durante hot-reload / test.
   */
  ngOnDestroy(): void {
    this.easterEgg.destroy();
  }

  initWonderPush(): void {
    window.WonderPush = window.WonderPush || [];
    window.WonderPush.push(['setUserConsent', true]);
    window.WonderPush.push([
      'init',
      {
        webKey:
          '2ea0e1cebe48d7889573ee679e87c32ea7b222e24615772a3c22f2ad10b87e97',
        serviceWorkerUrl: '/sw.js',
        requiresUserConsent: true,
        onSuccess: function () {
          // WonderPush SDK is fully initialized
          console.log('WonderPush SDK initialized successfully');
          // You can now safely access WonderPush features
          // For example, you can subscribe to notifications here
          // subscribeToNotifications();
        },
        onError: function (error: any) {
          // Error occurred during initialization
          console.error('WonderPush SDK initialization failed:', error);
        },
      },
    ]);
  }

}
